import { Link } from 'react-router-dom';
import { FOOTER_LINKS } from '../../constants/navigation';
import { CONTACT_EMAIL, ICP_NUMBER } from '../../constants/content';

export function Footer() {
  return (
    <footer className="bg-darker py-12 border-t border-purple-900/50">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row justify-between mb-8">
          <div className="mb-6 md:mb-0">
            <Link to="/" className="flex items-center space-x-2 mb-4">
              <span className="text-xl font-bold">Ameowzing</span>
            </Link>
            <p className="text-purple-300 max-w-xs text-sm leading-relaxed">
              专属冥想陪伴，守护你的每一次正念练习。让平静与温暖，伴你同行。
            </p>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            <FooterColumn title="产品服务" links={FOOTER_LINKS.products} />
            <FooterColumn title="帮助中心" links={FOOTER_LINKS.help} />
            <FooterColumn title="关于我们" links={FOOTER_LINKS.about} />
            <FooterColumn title="联系我们" links={FOOTER_LINKS.contact} />
          </div>
        </div>
        <div className="pt-8 border-t border-purple-900/50 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-purple-400 text-sm text-center md:text-left">
            Copyright © 2022-2026 All Rights Reserved. ICP证: {ICP_NUMBER}
          </p>
          <p className="text-purple-500 text-xs">
            冥想内容仅供放松与自我关怀参考，不构成医疗或心理咨询建议
          </p>
        </div>
      </div>
    </footer>
  );
}

function FooterColumn({ title, links }) {
  return (
    <div>
      <h4 className="font-semibold mb-4">{title}</h4>
      <ul className="space-y-2 text-purple-300 text-sm">
        {links.map((link) => (
          <li key={link.label}>
            {link.path ? (
              <Link to={link.path} className="hover:text-secondary transition-colors">
                {link.label}
              </Link>
            ) : (
              <a href={link.href} className="hover:text-secondary transition-colors">
                {link.label}
              </a>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}

export { CONTACT_EMAIL };
